module.exports = __webpack_public_path__ + "static/media/pip.3fdc07cb.mp3";